module.exports = __webpack_public_path__ + "img/furnitureshop-card-step.a8cb10ef.png";